/**===============公共方法集合==================== */
/**
 *
 */
import  XLSX from '../../static/utils/xlsx/xlsx.core.min'
import { Message } from 'element-ui';
export const debounce = (func,wait) => {
    let timeout;
    return function() {
        let context = this;
        let args = arguments;
        if (timeout) clearTimeout(timeout);
        if (!timeout) {
            timeout = setTimeout(() => {
                func.apply(context, args)
            }, wait)
        }

    }
}

export const xlsx = (json, fields, filename = '测试数据.xlsx',header) => {
    try{
        json.forEach(item => {
            for (let i in item) {
                if (fields.hasOwnProperty(i)) {
                    item[fields[i]] = item[i];
                }
                if(fields[i] != i){
                    delete item[i]; //删除原先的对象属性
                }
            }
        })
        let et = XLSX.utils.json_to_sheet(json,{ header:header });
        let wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, et, filename);
        XLSX.writeFile(wb, filename);
    }catch(e){
        console.log(e)
    }

}


/**
 *
* @description 按大到小排序
*/

export const mySort = (array, key) => {
	if (array instanceof Array) {
			if (key) {
                return array.sort(function(x, y) {
                    if (x[key] < y[key]) {
                        return 1
                    }
                    if (x[key] > y[key]) {
                        return -1
                    }
                    return 0
					})
			} else {
                return array.sort()
			}

	} else {
        return array
	}
}

/**
* @description 获取一个月，一周的日期，一天24小时
* @param type date-日，week-周，month-月
* @param date 日期
*/

export const getDateByType = (date, type) => {
    var result = []
    if (type === "month") {
        var end = moment(date).add('month', 1).add('days', -1).format('YYYY-MM-DD')
        var len = end.split("-")[2]
        for (var i = 1; i <= len; i++) {
            var element = date + "-";
            if (i < 10) element += "0";
            element += i
            result.push(element)
        }
    } else if (type === "week") {
        for (let i = 0; i < 7; i++) {
            var element = moment(date).subtract(i, "days").format("YYYY-MM-DD");
            result.unshift(element)
        }

    } else {
        result = [
            '00:00', '01:00', '02:00', '03:00',
            '04:00', '05:00', '06:00', '07:00',
            '08:00', '09:00', '10:00', '11:00',
            '12:00', '13:00', '14:00', '15:00',
            '16:00', '17:00', '18:00', '19:00',
            '20:00', '21:00', '22:00', '23:00'
        ]
    }
    return result;
}
/**
 * @description 地图方向翻译
 * @param {*} rotation
 */
export const setRotation = (rotation) => {
    var r = /\d{1,}\.{0,1}\d{0,}/
    if (r.test(rotation)) {
        var result = ''
        var data = (parseInt(rotation) - 90)
        if (data < 0) {
                data = (360 + data)
        }
        if (data > 0 && data < 90) {
                result = '由西北向东南'
        }
        if (data == 90) {
                result = '由北向南'
        }
        if (data > 90 && data < 180) {
                result = '由东北向西南'
        }
        if (data == 180) {
                result = '由东向西'
        }
        if (data > 180 && data < 270) {
                result = '由东南向西北'
        }
        if (data == 270) {
                result = '由南向北'
        }
        if (data > 270 && data < 360) {
                result = '由西南向东北'
        }
        return result
    } else {
        return ''
    }
}

/**
 * @description 设置echarts
 * 设置图表
 */
export const setLineEcharts = obj => {
	let option = {};
	// 无数据时初始化0
	let initSeriesData = [];
	if (obj.xAxis) {
        for (let i of obj.xAxis.data) {
            initSeriesData.push(0);
        }
	} else {
        for (let i of xAxisInitData) {
            initSeriesData.push(0);
        }
	}
    let titleText = "";
    let color = [];
    let xAxisData = [];
    let seriesData = [];
    let xlabelRotate = 0;
    // 获取数据
    if (obj) {
        // 设置title
        if (obj.title) {
            titleText = obj.title.text;
        }
        // 设置color
        if (obj.color) {
            color = obj.color;
        }
        // 设置横坐标
        if (obj.xAxis) {
            xAxisData = obj.xAxis.data;
            // 设置横坐标标签倾斜
            if (obj.xAxis.axisLabel) {
                xlabelRotate = obj.xAxis.axisLabel.rotate;
            }
        }
        // 设置值
        if (obj.series) {
            seriesData = obj.series;
        }
        // 设置option
        option = {
            title: {
                text: (titleText ? titleText : ''),
                top: '20',
                left: 'center',
                textStyle: {
                        fontWeight: 'lighter'
                },
            },
            color: (color.length ? color : ['#f69846', '#f6d54a']),
            legend: {
                show: true,
                left: 'center',
                bottom: '40',
                textStyle: {
                    fontSize: 14
                }
            },
            tooltip: {
                trigger: 'axis',
            },
            grid: {
                left: '24',
                right: '40',
                top: '70',
                bottom: '90',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: xAxisData,
                splitLine: {
                    show: false,
                },
                splitArea: {
                    interval: 0
                },
                axisLabel: {
                        interval: 0,
                        rotate: (xlabelRotate ? xlabelRotate : 0),
                        margin: 24,
                        textStyle: {
                                align: 'center'
                        }
                },
                axisTick: {
                        show: false
                }
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        type: 'dashed',
                        color: '#eeeeee'
                    }
                },
                axisTick: {
                    show: false
                }
            },
            series: (seriesData.length ? seriesData : [{
                type: 'line',
                data: initSeriesData
            }])
        };
        return option;
    }
}
// echarts饼状图
export const setPieEcharts = obj => {
    let option = {};
    let color = [];
    let titleText = "";
    let legendData = [];
    let seriesData = "";
    let tooltipData = {};
    // 获取数据
    if (obj) {
    // 设置title
        if (obj.title) {
            titleText = obj.title.text;
        }
        // 设置color
        if (obj.color) {
            color = obj.color;
        }
        // 设置值、设置legend
        if (obj.series) {
            seriesData = obj.series;
            for (let i of obj.series[0].data) {
                legendData.push(i.name);
            }
        }
        // tooltip
        if (obj.tooltip) {
            tooltipData = obj.tooltip;
        }
    }
    // 设置option
    option = {
        title: {
            text: (titleText ? titleText : ''),
            top: '30',
            left: 'center',
            textStyle: {
                fontWeight: 'lighter'
            },
        },
        legend: {
            show: true,
            left: 'center',
            bottom: '50',
            textStyle: {
                    fontSize: 14
            },
            data: legendData
        },
        tooltip: tooltipData,
        series: seriesData
    };
    return option;
}
